import {Map, List, fromJS} from 'immutable';
import axios from "axios";
import { toast } from "react-toastify";

export const types = {
    INIT: 'RETAILER/INIT',
    FETCH_STORES: 'RETAILER/FETCH_STORES',
    FETCH_STORES_SUCCESS: 'RETAILER/FETCH_STORES_SUCCESS',
    FETCH_RETAILERS_SUCCESS: 'RETAILER/FETCH_RETAILERS_SUCCESS',
    FETCH_IPOS_CONFIG_SUCCESS: 'RETAILER/FETCH_IPOS_CONFIG_SUCCESS',
    UPDATE_RETAILER_SEARCH_QUERY: 'RETAILER/UPDATE_RETAILER_SEARCH_QUERY',
    UPDATE_STORE_SEARCH_QUERY: 'RETAILER/UPDATE_STORE_SEARCH_QUERY',
};

export const initialState = fromJS({
    stores: [],
    retailers: [],
    iposConfigurations: [],
    retailerSearchQuery: '',
    storeSearchQuery: ''
});

export default (state = initialState, action) => {
    switch (action.type) {
        case types.INIT:
            return state;
        case types.FETCH_STORES_SUCCESS:
            return state.set('stores', fromJS(action.stores));
        case types.FETCH_RETAILERS_SUCCESS:
            return state.set('retailers', fromJS(action.retailers));
        case types.FETCH_IPOS_CONFIG_SUCCESS:
            return state.set('iposConfigurations', fromJS(action.iposConfigurations));
        case types.UPDATE_RETAILER_SEARCH_QUERY:
            return state.set('retailerSearchQuery', fromJS(action.query));
        case types.UPDATE_STORE_SEARCH_QUERY:
            return state.set('storeSearchQuery', fromJS(action.query));
        default:
            return state
    }
};

export const fetchStoresAndRetailers = () => {
    return function (dispatch) {
        dispatch(fetchStores()).then(dispatch(fetchRetailers()));
    }
};

export const fetchStores = () => {
    return function (dispatch) {
        let path = __API__ + '/api/ui/store';

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(stores => {
                dispatch(fetchStoresSuccess(stores));
            })
            .catch(error => {
                console.log(error)
                // dispatch(errorHandler(error.response))
            });
    }
};

export const fetchStoresSuccess = (stores) => {
    return {
        type: types.FETCH_STORES_SUCCESS,
        stores: stores
    };
};

export const updateRetailerSearchQuery = (query) => {
    return {
        type: types.UPDATE_RETAILER_SEARCH_QUERY,
        query: query
    };
};

export const updateStoreSearchQuery = (query) => {
    return {
        type: types.UPDATE_STORE_SEARCH_QUERY,
        query: query
    };
};

export const changeReplenishmentStrategy = (storeGln, strategy) => {
    return function (dispatch) {
        const path =  __API__ + `/api/ui/store/${storeGln}/replenishmentstrategy`;

        const command = {
            replenishmentStrategy: strategy
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchStoresAndRetailers());
                toast.success('Änderung erfolgreich gespeichert!');
            })
            .catch(error => {
                dispatch(fetchStoresAndRetailers());
                toast.error('Änderung konnte nicht gespeichert werden!');
            });
    }
};

export const updateStoreGln = (oldGln, newGln) => {
    return function (dispatch, getState) {
        const path = __API__ + `/api/ui/store/${oldGln}/gln`;

        const command = {
            oldStoreGln: oldGln,
            newStoreGln: newGln,
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchStoresAndRetailers());
                toast.success('Änderung erfolgreich gespeichert!');
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchStores()).then(() => {
                    toast.error('Änderung konnte nicht gespeichert werden!');
                });
            });
    }
};

export const updateStoreAddress = (storeGln, newAddress) => {
    return function (dispatch, getState) {
        const path = __API__ + `/api/ui/store/${storeGln}/address`;

        const command = {
            storeGln: storeGln,
            street: newAddress.street,
            zipCode: newAddress.zipCode,
            city: newAddress.city,
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchStoresAndRetailers());
                toast.success('Änderung erfolgreich gespeichert!');
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchStores()).then(() => {
                    toast.error('Änderung konnte nicht gespeichert werden!');
                });
            });
    }
};

export const setStoreForDelivery = (storeGln, storeForDeliveryGln) => {
    return function (dispatch, getState) {
        const path = __API__ + `/api/ui/store/${storeGln}/storefordelivery`;

        const command = {
            storeGln: storeGln,
            storeForDeliveryGln: storeForDeliveryGln,
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchStoresAndRetailers());
                toast.success('Änderung erfolgreich gespeichert!');
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchStores()).then(() => {
                    toast.error('Änderung konnte nicht gespeichert werden!');
                });
            });
    }
};

export const assignStoreToRetailer = (storeGln, retailerGln) => {
    return function (dispatch, getState) {
        const path = __API__ + `/api/ui/store/${storeGln}/retailer`;

        const command = {
            retailerGln: retailerGln,
            storeGln: storeGln
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchStoresAndRetailers());
                toast.success('Store wurde dem Händler erfolgreich zugewiesen!');
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchStores()).then(() => {
                    toast.error('Änderung konnte nicht gespeichert werden!');
                });
            });
    }
};

export const createNewStore = (store) => {
    return function (dispatch, getState) {
        const path = __API__ + '/api/ui/store';

        const command = {
            retailerGln: store.retailerGln,
            storeGln: store.storeGln,
            street: store.street,
            zipCode: store.zipCode,
            city: store.city,
            confederation: store.confederation,
            replenishmentStrategy: store.replenishmentStrategy
        };

        return axios.post(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchStoresAndRetailers());
                toast.success('Store wurde angelegt!');
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchStores()).then(() => {
                    toast.error('Store konnte nicht gespeichert werden!');
                });
            });
    }
};

export const fetchRetailers = () => {
    return function (dispatch) {
        let path = __API__ + '/api/ui/retailer';

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(retailers => {
                dispatch(fetchRetailersSuccess(retailers));
            })
            .catch(error => {
                toast.error('Händler konnten nicht geladen werden!');
            });
    }
};

export const fetchRetailersSuccess = (retailers) => {
    return {
        type: types.FETCH_RETAILERS_SUCCESS,
        retailers: retailers
    };
};

export const fetchIposConfigurations = () => {
    return function (dispatch) {
        let path = __API__ + '/api/ui/retailer/iposconfig';

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(iposConfigurations => {
                dispatch(fetchIposConfigurationsSuccess(iposConfigurations));
            })
            .catch(error => {
                console.log(error);
                toast.error('IPOS-Einstellungen konnten nicht geladen werden!');
            });
    }
};

export const fetchIposConfigurationsSuccess = (iposConfigurations) => {
    return {
        type: types.FETCH_IPOS_CONFIG_SUCCESS,
        iposConfigurations: iposConfigurations
    };
};

export const createIposConfiguration = (iposConfig) => {
    return function (dispatch, getState) {
        const path = __API__ + '/api/ui/retailer/iposconfig';

        const command = {
            retailerGln: iposConfig.retailerGln,
            username: iposConfig.username,
            password: iposConfig.password
        };

        return axios.post(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchIposConfigurations());
                toast.success('Konfiguration wurde angelegt!');
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchIposConfigurations()).then(() => {
                    toast.error('Konfiguration konnte nicht gespeichert werden!!');
                });
            });
    }
};

export const updateIposConfiguration = (retailerGln, username, password) => {
    return function (dispatch, getState) {
        const path = __API__ + `/api/ui/retailer/${retailerGln}/iposconfig`;

        const command = {
            retailerGln: retailerGln,
            username: username,
            password: password
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchIposConfigurations());
                toast.success('Änderung erfolgreich gespeichert!');
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchIposConfigurations()).then(() => {
                    toast.error('Änderung konnte nicht gespeichert werden!');
                });
            });
    }
};

export const deleteIposConfiguration = (retailerGln) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/retailer/${retailerGln}/iposconfig`;

        const command = {
            retailerGln: retailerGln
        };

        return axios.delete(path, {
            data: command})
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchIposConfigurations());
                toast.success('Konfiguration erfolgreich gelöscht!');
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchIposConfigurations()).then(() => {
                    toast.error('Konfiguration konnte nicht gelöscht werden!');
                });
            });
    }
};

export const updateRetailerGln = (oldGln, newGln) => {
    return function (dispatch, getState) {
        const path = __API__ + `/api/ui/retailer/${oldGln}/gln`;

        const command = {
            oldRetailerGln: oldGln,
            newRetailerGln: newGln,
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchStoresAndRetailers());
                toast.success('Änderung erfolgreich gespeichert!');
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchRetailers()).then(() => {
                    toast.error('Änderung konnte nicht gespeichert werden!');
                });
            });
    }
};

export const updateRetailerName = (retailerGln, newName) => {
    return function (dispatch, getState) {
        const path = __API__ + `/api/ui/retailer/${retailerGln}/name`;

        const command = {
            retailerGln: retailerGln,
            name: newName,
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchStoresAndRetailers());
                toast.success('Änderung erfolgreich gespeichert!');
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchStoresAndRetailers()).then(() => {
                    toast.error('Änderung konnte nicht gespeichert werden!');
                });
            });
    }
};

export const createNewRetailer = (retailer) => {
    return function (dispatch, getState) {
        const path = __API__ + '/api/ui/retailer';

        const command = {
            gln: retailer.retailerGln,
            name: retailer.name
        };

        return axios.post(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchStoresAndRetailers());
                toast.success('Händler wurde angelegt!');
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchStores()).then(() => {
                    toast.error('Händler konnte nicht gespeichert werden!');
                });
            });
    }
};

export const deleteRetailer = (gln) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/retailer/${gln}`;

        const command = {
            gln: gln
        };

        return axios.delete(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchStoresAndRetailers());
                toast.success('Händler erfolgreich gelöscht!');
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchRetailers()).then(() => {
                    toast.error('Händler konnte nicht gelöscht werden!');
                });
            });
    }
};

//selectors
export const getRetailers = (state) => {
    if (!state.has('retailers') || !state.has('retailerSearchQuery')) {
        return List();
    }

    if(!state.get('retailerSearchQuery')) {
        return state.get('retailers');
    }

    const queryTokens = state.get('retailerSearchQuery').split(' ');

    const searchProperties = [
        'gln', 'name'
    ];

    return state.get('retailers').filter((retailer) => {
        return queryTokens.every((token) => {
            return searchProperties.some((propertyPath) => {
                let path = propertyPath.split('.');
                return retailer.getIn(path).toLowerCase().indexOf(token.toLowerCase()) > -1;
            });
        });
    })
};

export const getStores = (state) => {
    if (!state.has('stores') || !state.has('storeSearchQuery')) {
        return List();
    }

    if(!state.get('storeSearchQuery')) {
        return state.get('stores');
    }

    const queryTokens = state.get('storeSearchQuery').split(' ');

    const searchProperties = [
        'city', 'gln', 'street', 'zipCode', 'confederation', 'retailer.gln', 'retailer.name'
    ];

    return state.get('stores').filter((store) => {
        return queryTokens.every((token) => {
            return searchProperties.some((propertyPath) => {
                let path = propertyPath.split('.');
                return store.getIn(path).toLowerCase().indexOf(token.toLowerCase()) > -1;
            });
        });
    })
};


export const getStoresNotAssignedToModule = (allStores, storeGlnsAssignedToModule) => {
    if (!allStores) {
        return List();
    }

    if (!storeGlnsAssignedToModule) {
        return List();
    }

    return allStores.filter((store) => {
        return !storeGlnsAssignedToModule.find((assignedGln) => store.get('gln') === assignedGln);
    });
};



// WEBPACK FOOTER //
// ./src/admin/retailer/reducer.js